import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import PrivateRoute from "PrivateRoute";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import moment from "moment";
import "./App.scss";
import "./index.css";

import { doLogout } from "./actions/authAction";
import { logEvent } from "firebase/analytics";
import { maintenancePageState } from "./actions/maintenanceAction";
import { BASE_URL } from "./actions/constant";
import { analytics } from "./firebase";
import Tags from "./tags";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Private
const Page404 = React.lazy(() => import("./views/Pages/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500"));
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/Pages/Login"));
const Register = React.lazy(() => import("./views/Pages/Register"));
const RegisterSuccess = React.lazy(() =>
  import("./views/Pages/Register/RegisterSuccess")
);
const ForgotPassword = React.lazy(() =>
  import("./views/Pages/ForgotPassword/ForgotPassword")
);
const ResetPassword = React.lazy(() =>
  import("./views/Pages/ForgotPassword/ResetPassword")
);
const ForgotPasswordSuccess = React.lazy(() =>
  import("./views/Pages/ForgotPassword/ForgotPasswordSuccess")
);
const Maintenance = React.lazy(() => import("./views/Pages/maintenancePage"));
const PiExpired = React.lazy(() => import("./views/Pages/PiExpired/PiExpired"));
const Landing = React.lazy(() => import("./views/LandingPage"));
const Portal = React.lazy(() => import("./views/Pages/Portal"));
const PortalJadwalOp = React.lazy(() =>
  import("./views/Pages/Portal/Content/JadwalPortal")
);
const PortalLanding = React.lazy(() =>
  import("./views/Pages/Portal/Content/LandingPage")
);
const PortalDetail = React.lazy(() =>
  import("./views/Pages/Portal/Content/Detail")
);
const ProdukPortal = React.lazy(() =>
  import("./views/Pages/Portal/Content/ProdukPortal")
);
const BiayaPengiriman = React.lazy(() =>
  import("./views/Pages/Portal/Content/BiayaPengiriman")
);
const Trayek = React.lazy(() => import("./views/Pages/Portal/Content/Trayek"));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenance: false,
      preMaintenance: false,
      message: "",
      mulai: "",
      habis: "",
    };
  }

  componentDidMount() {
    this.cekMaintenance();
  }

  cekMaintenance = async () => {
    let config = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await fetch(BASE_URL + "check_maintenance", config);
      if (!res.ok) {
        throw Error(res.statusText);
      }
      const resJson = await res.json();
      if (resJson.status === 0) {
        this.props.maintenancePageState({
          maintenance: true,
          loginStat: true,
          role: "",
        });
      } else if (resJson.status === 1) {
        this.setState({
          preMaintenance: true,
          message: resJson.data[0].keterangan,
          mulai: resJson.data[0].tgl_jam_mulai,
          habis: resJson.data[0].tgl_jam_selesai,
        });
      }
      if (resJson.status === 400) {
        this.setState({ maintenance: false, preMaintenance: false });
      }
    } catch (err) {
      window.alert("Error Connection");
    }
  };

  close = () => {
    this.setState({ preMaintenance: false });
  };

  render() {
    // console.log("PROPS ===>>> ", this.props);
    // console.log("STATE ===>>> ", this.state);

    logEvent(analytics, "screen_view", {
      firebase_screen: window.location.pathname,
      firebase_screen_class: window.location.pathname,
    });

    return (
      <React.Suspense fallback={loading()}>
        {process.env.REACT_APP_ENV && <Tags />}
        <Modal isOpen={this.state.preMaintenance}>
          <ModalHeader>Akan dilakukan maintenance pada sistem</ModalHeader>
          <ModalBody>
            <table>
              <tbody>
                <tr>
                  <td>
                    <strong>Mulai</strong>
                  </td>
                  <td>
                    <strong> : </strong>
                  </td>
                  <td>
                    {moment(this.state.mulai).format("DD MMMM YYYY, HH:mm:ss")}{" "}
                    WIB
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Selesai</strong>
                  </td>
                  <td>
                    <strong> : </strong>
                  </td>
                  <td>
                    {moment(this.state.habis).format("DD MMMM YYYY, HH:mm:ss")}{" "}
                    WIB
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Keterangan</strong>
                  </td>
                  <td>
                    <strong> : </strong>
                  </td>
                  <td>{this.state.message}</td>
                </tr>
              </tbody>
            </table>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.close}>
              Tutup
            </Button>
          </ModalFooter>
        </Modal>

        <Switch>
          <Route
            exact
            path="/maintenancepage"
            name="maintenance"
            render={(props) => <Maintenance {...props} />}
          />
          <Route
            exact
            path="/404"
            name="Page 404"
            render={(props) => <Page404 {...props} />}
          />
          <Route
            exact
            path="/500"
            name="Page 500"
            render={(props) => <Page500 {...props} />}
          />
          {this.props.maintenancePageData.maintenance &&
            this.props.maintenancePageData.loginStat &&
            localStorage.getItem("tolaut@typeUser") !== "6" && <Maintenance />}
          <Route
            exact
            path="/login"
            name="Page Login"
            render={(props) => (
              <Login isAuthenticated={this.props.isAuthenticated} {...props} />
            )}
          />
          <Route
            exact
            path="/register"
            name="Page Register"
            render={(props) => <Register {...props} />}
          />
          <Route
            exact
            path="/register/success"
            name="Page Register Success"
            render={(props) => <RegisterSuccess {...props} />}
          />
          <Route
            exact
            path="/forgot-password"
            name="Forgot Password"
            render={(props) => <ForgotPassword {...props} />}
          />
          <Route
            exact
            path="/reset-password/:token"
            name="Reset Password"
            render={(props) => <ResetPassword {...props} />}
          />
          <Route
            exact
            path="/forgot/password/success"
            name="Page Reset Password Success"
            render={(props) => <ForgotPasswordSuccess {...props} />}
          />
          <Route
            exact
            path="/expired/:status"
            name="Page Expired"
            render={(props) => <PiExpired {...props} />}
          />
          <Route
            exact
            path="/purchase-order/:token"
            name="Purchase Order"
            render={(props) => <Landing {...props} />}
          />
          <Route
            exact
            path="/detail/jadwal-kapal"
            name="Detail"
            render={(props) => (
              <Portal {...props} banner={true}>
                <PortalJadwalOp />
              </Portal>
            )}
          />
          <Route
            exact
            path="/detail/trayek"
            name="Detail"
            render={(props) => (
              <Portal {...props} banner={true}>
                <Trayek />
              </Portal>
            )}
          />
          <Route
            exact
            path="/detail/produk"
            name="Detail"
            render={(props) => (
              <Portal {...props} banner={true}>
                <ProdukPortal />
              </Portal>
            )}
          />
          <Route
            exact
            path="/detail/:name"
            name="Portal Sitolaut"
            render={(props) => (
              <Portal {...props} banner={false}>
                <PortalDetail {...props} />
              </Portal>
            )}
          />
          <Route
            exact
            path="/"
            name="Portal Sitolaut"
            render={(props) => (
              <Portal {...props} banner={true}>
                <PortalLanding />
              </Portal>
            )}
          />
          <Route
            exact
            path="/biaya-pengiriman"
            name="Biaya Pengiriman"
            render={(props) => (
              <Portal {...props} banner={true}>
                <BiayaPengiriman />
              </Portal>
            )}
          />
          <PrivateRoute
            path="/"
            name="Home"
            render={(props) => <DefaultLayout {...props} />}
            isAuthenticated={this.props.isAuthenticated}
          />
        </Switch>
      </React.Suspense>
    );
  }
}

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    maintenancePageData: state.maintenance.maintenancePageData,
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doLogout: () => dispatch(doLogout()),
    maintenancePageState: (val) => dispatch(maintenancePageState(val)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
